// Pure helpers for the Schwab login countdown (testable with node --test; the component is SchwabLoginCountdown.jsx).
export function formatCountdown(ms) {
  if (ms <= 0) return 'OVERDUE'
  const s = Math.floor(ms / 1000)
  const d = Math.floor(s / 86400)
  const h = Math.floor((s % 86400) / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  if (d > 0) return `${d}d ${h}h ${m}m`
  if (h > 0) return `${h}h ${m}m ${sec}s`
  return `${m}m ${sec}s`
}

export function tokenTone(ms) {
  if (ms <= 0) return { color: '#f43f5e', label: 'LOG IN NOW', level: 'bad' }
  const h = ms / 3_600_000
  if (h <= 24) return { color: '#fb7185', label: 'LOG IN TODAY', level: 'bad' }
  if (h <= 48) return { color: '#fbbf24', label: 'LOG IN SOON', level: 'warn' }
  return { color: '#34d399', label: 'OK', level: 'ok' }
}
